import { geohashForLocation } from 'geofire-common';

/**
 * Convert (lat, lon) to a 3-char geohash prefix (~156km × 156km — metro scope).
 * @param {number} lat
 * @param {number} lon
 * @returns {string}
 */
export function latLonToGeohash3(lat, lon) {
  return geohashForLocation([lat, lon]).slice(0, 3);
}

/**
 * Resolve a personalization scope from a location object, or null when no
 * location is set.
 * @param {{latitude?: number, longitude?: number}|null|undefined} location
 * @returns {string|null}
 */
export function scopeFromLocation(location) {
  if (!location) return null;
  const lat = Number(location.latitude);
  const lon = Number(location.longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
  return latLonToGeohash3(lat, lon);
}
